import type { GraphQLTypes, InputType } from '@zeus/index'
import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const requestFields = { id: true, createdAt: true, updatedAt: true, needs: true, status: true, response: true, handledAt: true } as const
const referentFields = { name: true, contact: true } as const

/** Accueil des personnes en situation de handicap (#327). */
export const GQL_ACCOMMODATION_REQUESTS = typedGql('query', { scalars })({
  accommodationRequests: { ...requestFields, learnerName: true, learnerEmail: true },
})

export const GQL_RESPOND_ACCOMMODATION = typedGql('mutation', { scalars })({
  respondAccommodation: [{ input: $('input', 'RespondAccommodationInput!') }, true],
})

export const GQL_DISABILITY_REFERENT = typedGql('query', { scalars })({ disabilityReferent: referentFields })

export const GQL_UPDATE_DISABILITY_REFERENT = typedGql('mutation', { scalars })({
  updateDisabilityReferent: [{ input: $('input', 'DisabilityReferentInput!') }, referentFields],
})

/** Côté apprenant : le référent, et sa demande s'il en a fait une. */
export const GQL_MY_ACCOMMODATION = typedGql('query', { scalars })({
  myAccommodation: { referent: referentFields, request: requestFields },
})

export const GQL_SUBMIT_ACCOMMODATION = typedGql('mutation', { scalars })({
  submitAccommodation: [{ input: $('input', 'SubmitAccommodationInput!') }, { id: true }],
})

export const GQL_WITHDRAW_ACCOMMODATION = typedGql('mutation', { scalars })({ withdrawAccommodation: true })

export type OrgAccommodationRequest = InputType<GraphQLTypes['OrgAccommodationRequestModel'], typeof requestFields & { learnerName: true, learnerEmail: true }, typeof scalars>
export type MyAccommodation = InputType<GraphQLTypes['MyAccommodationModel'], { referent: typeof referentFields, request: typeof requestFields }, typeof scalars>
